import React from 'react';
import Stack from 'react-bootstrap/Stack';
import CandidateCompareHeader from '../../components/candidate-compare/candidate-compare-header';
import CandidateCompareContent from '../../components/candidate-compare/candidate-compare-content';

function CandidateCompare() {
  return (
    <Stack gap={1}>
      <CandidateCompareHeader />
      <CandidateCompareContent />
    </Stack>
  );
}

export default CandidateCompare;
